import { render, staticRenderFns } from "./CreateOrUpdateSchool.vue?vue&type=template&id=be698250&"
import script from "./CreateOrUpdateSchool.vue?vue&type=script&lang=js&"
export * from "./CreateOrUpdateSchool.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports